import { Stack, Icon, Text, Heading } from "@chakra-ui/react";

import { WalletIcon } from "../../../icons";
import { AddCardButton } from "../AddCard";
import { ToPaymentsButton } from "./ToPaymentsButton.tsx";

export function EmptyCardListView() {
  return (
    <>
      <Stack spacing={0} alignItems="center" mb="22px" p="20px" pb="30px" bg="white" borderRadius="16px">
        <Icon as={WalletIcon} boxSize="80px" mb="9px" />

        <Heading maxW="300px" textAlign="center" lineHeight="24px" mb="11px">
          У вас нет привязанных способов оплаты
        </Heading>

        <Text maxW="300px" textAlign="center">
          Привяжите способ оплаты, чтобы использовать его
          для следующих платежей
        </Text>
      </Stack>

      <AddCardButton />
      <ToPaymentsButton />
    </>
  );
}
